import { render, staticRenderFns } from "./DeptDialog.vue?vue&type=template&id=358635c4&scoped=true"
import script from "./DeptDialog.vue?vue&type=script&lang=js"
export * from "./DeptDialog.vue?vue&type=script&lang=js"
import style0 from "./DeptDialog.vue?vue&type=style&index=0&id=358635c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358635c4",
  null
  
)

export default component.exports